import * as React from "react";
import RbButton, {
  ButtonType,
} from "../../../bosch-react/components/button/RbButton";
import { connect } from "react-redux";
import "../../../core/scss/_customize.scss";
import { RootState } from "../../../store/store";
import { IStep } from "../types";
import { init, updateStep, validateData } from "../actions";
import { uploadReportDispatch, getDocumentTypesDispatch } from "../thunks";
import { IUserProfile } from "../../Auth/types";
import { confirmDialog, showDialog } from "../../Dialog/actions";
import Constants from "../../../core/libraries/Constants";
import { isBoolean } from "lodash";


interface CommandButtonsProps {
  userProfile: IUserProfile|undefined;
  steps: IStep[];
  report: any;
  mode: string;
  updateStep: typeof updateStep;
  validateData: typeof validateData;
  uploadReportDispatch: any;
  showDialog: typeof showDialog;
  confirmDialog: typeof confirmDialog;
  init: typeof init;
  getDocumentTypesDispatch: any;
}

class CommandButtons extends React.Component<CommandButtonsProps, any> {
  constructor(props: any) {
    super(props);
    this.goToStep = this.goToStep.bind(this);
    this.resetStep = this.resetStep.bind(this);
  }
  render() {
    let buttonsArr: any[] = [];
    const currentStepIndex: number = this.props.steps.findIndex(
      (step) => !!step.isSelected
    );
    if (currentStepIndex !== 0) {
      buttonsArr.push(
        <RbButton
          type={ButtonType.Secondary}
          label="Cancel"
          key="Cancel"
          onClick={() => {
            this.resetStep();
          }}
        />
      );
      buttonsArr.push(
        <RbButton
          label="Previous"
          key="Previous"
          onClick={() => {
            this.goToStep(-1);
          }}
        />
      );
    }
    if (
      currentStepIndex >= 0 &&
      currentStepIndex < this.props.steps.length - 1
    ) {
      buttonsArr.push(
        <RbButton
          label="Next"
          key="Next"
          onClick={() => {
            this.goToStep(1);
          }}
        />
      );
    }
    if (currentStepIndex === this.props.steps.length - 1) {
      buttonsArr.push(
        <RbButton
          label="Finish"
          key="Finish"
          onClick={() => {
            this.goToStep(0);
          }}
        />
      );
    }
    return <div className="upload-buttons">{buttonsArr}</div>;
  }
  goToStep(stepMove: number) {
    this.props.validateData(async (result: boolean) => {
      if (result === true ||stepMove<0) {
        if (stepMove !== 0) {
          // Previous or Next
          const currentStep = this.props.steps.find(
            (step) => !!step.isSelected
          )!;
          currentStep.valid = true;
          if (!!currentStep.valid) {
            currentStep.isSelected = false;
            this.props.updateStep(currentStep);
            this.props.steps.forEach((step: IStep, index: number) => {
              if (step.label === currentStep.label) {
                let expectedStep = this.props.steps[index + stepMove];
                expectedStep.valid = true;
                expectedStep.isSelected = true;
                this.props.updateStep(expectedStep);
              }
            });
          }
        } else {
          this.props.showDialog(Constants.DIALOG_MESSAGE.UPLOAD);
          this.props.uploadReportDispatch(
            this.props.report,
            this.props.mode,
            (result: any) => {
              this.props.showDialog(false);
              if (
                result === true ||
                (isBoolean(result) === false && result.Status === "Success")
              ) {
                this.props.confirmDialog(
                  Constants.REPORT_MESSAGE.UPLOAD.TITLE,
                  this.props.mode === "admin"
                    ? Constants.REPORT_MESSAGE.UPLOAD.SUCCESS_ADMIN
                    : Constants.REPORT_MESSAGE.UPLOAD.SUCCESS_USER,
                  true,
                  () => {
                    window.location.href ="/";
                  },
                  null,
                  this.props.report.UploadType === "Thesis"
                );
              } else {
                let errorMessage = "";
                if (result === false) {
                  errorMessage = "Cannot create report";
                } else if (result === 401) {
                  errorMessage =
                    "Your token has expired. Press F5 to reload the page";
                } else {
                  errorMessage = result.Message;
                }
                this.props.confirmDialog(
                  Constants.REPORT_MESSAGE.UPLOAD.TITLE,
                  Constants.REPORT_MESSAGE.UPLOAD.FAILED.replace(
                    "{0}",
                    errorMessage
                  ),
                  true,
                  () => {
                    // Do nothing, allow the user stay at the same page
                  }
                );
              }
            }
          );
        }
      } else {
        //set step to red
        const currentStep = this.props.steps.find((step) => !!step.isSelected)!;
        currentStep.valid = false;
        this.props.updateStep(currentStep);
      }
    });
  }

  resetStep() {
    this.props.confirmDialog(
      Constants.CONFIRMATION_MESSAGE.CAUTION,
      Constants.CONFIRMATION_MESSAGE.CANCEL_UPLOAD_WARNING,
      false,
      () => {
        this.props.init(this.props.mode === "admin" ? "admin" : "user");
        this.props.getDocumentTypesDispatch("RnD");
        this.props.getDocumentTypesDispatch("Thesis");
        this.props.getDocumentTypesDispatch("Paper");
        if (
          !this.props.userProfile?.permissions?.checkHasPermission([
            Constants.PERMISSIONS.ADMIN,
          ]) &&
          this.props.mode === "admin"
        ) {
          /* Access Dialog */
          this.props.confirmDialog(
            Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.TITLE,
            Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT,
            true,
            () => {
              window.location.href = "/";
            }
          );
        }
      }
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
  steps: state.upload.steps,
  report: state.upload.commonReport,
  mode: state.upload.mode,
});
export default connect(mapStateToProps, {
  updateStep,
  validateData,
  uploadReportDispatch,
  showDialog,
  confirmDialog,
  init,
  getDocumentTypesDispatch,
})(CommandButtons);
